module.exports = __webpack_public_path__ + "media/website/home_banner-3b430704.png";